<template>
  <section class="iorder-menu">
    <menu-banner v-bind="props" />
    <div v-if="isLoading" class="iorder-menu__loading">
      <span class="sr-only" role="alert" aria-live="assertive">
        {{ $t('iorder-content-loading') }}
      </span>
      <loading-placeholder :items-number="placeholderItems" modifier-name="iorder" />
    </div>
    <i-order-menu-main
      v-model:is-loading="isLoading"
      :fields="fields"
      :params="params"
      :i-order-menu-rendering="rendering"
    />
  </section>
</template>

<script setup lang="ts">
import type { IOrderMenuProps, IOrderMenuFields } from './types';
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { isServer } from '@sitecore-jss/sitecore-jss/utils';
import MenuBanner from './MenuBanner/MenuBanner.vue';
import LoadingPlaceholder from '../2_elements/LoadingPlaceholder/LoadingPlaceholder.vue';
import IOrderMenuMain from './IOrderMenuMain.vue';
import useMedia from '../../utils/useMedia';
import { useAppStore } from '../../stores/appStore';
import { useJssStore } from '../../stores/jssStore';

const appStore = useAppStore();
const jssStore = useJssStore();
const useSSR =
  (jssStore.$state as unknown as Record<string, unknown>)['Feature.Menus.UseSSR'] === 'true';

const props = withDefaults(defineProps<IOrderMenuProps>(), {
  fields: () => ({}) as IOrderMenuFields,
  params: () => ({}),
});

const cachedMenus = useSSR ? appStore.getCachedMenus(jssStore.venueId) : undefined;
const isLoading = ref(isServer() ? !useSSR : !cachedMenus);
const { isMedia: isTablet } = useMedia('(min-width: 768px)');
const { isMedia: isDesktop } = useMedia('(min-width: 1024px)');

const placeholderItems = computed(() => {
  if (isDesktop.value) return 9;
  return isTablet.value ? 8 : 3;
});

onBeforeUnmount(() => {
  appStore.disableSmoothScroll(false);
});

onMounted(() => {
  appStore.disableSmoothScroll(true);
});
</script>

<style lang="scss">
@import './scss/IOrderMenu.scss';
</style>
